<template>
  <div class="number-grow-warp">
    <span>￥{{this.startMoney|formatCurrency}}</span>
  </div>
</template>
<script>
/*eslint-disable*/
import { filter } from '@/common/index';
import { mapState, mapMutations } from 'vuex';

  export default {
    props: {
      time: {
        type: Number,
        default: 30
      },
      value: {
        type: Number,
        default: 720000
      }
    },
    filters: {
      formatCurrency(time){
        time-=600000000
        return filter.formatCurrency(time)
      },
    },
    data() {
      return {
        timer: '',
        current: '',
        start: '',
      }
    },
    computed: {
      ...mapState({
        startMoney: state => state.startMoney
      })
    },
    methods: {
      ...mapMutations(['add_startMoney']),
      numberGrow () {
        let _this = this;
        // let step = (_this.value * 10) / (_this.time * 1000)
        this.timer = setInterval(function () {
          let num = Math.random()*15;
          let moneyNum = parseFloat(num.toFixed(2));
          _this.add_startMoney(moneyNum)
        }, 1500)
      }
    },
    mounted () {
      this.start = this.startMoney;
      this.numberGrow();
    },
    destroyed() {
      clearInterval(this.timer);
      this.timer = ''
    }
  }
</script>
<style scoped lang="scss">
  .number-grow-warp{


  }
  .number-grow {
    font-family: Arial-BoldMT;
    font-size: 25px;
    color: #ffaf00;
    letter-spacing: 2.67px;
    display: inline-block;
    line-height:60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/base/numberRun.vue